var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "message-list--employment-info" }, [
    _c(
      "div",
      { staticClass: "message-list--employment-info-jon" },
      [_c("Jon", { attrs: { white: "" } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "message-list--employment-info-content" }, [
      _c("div", { staticClass: "message-list--employment-info-title" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "message-list--employment-info-subtitle" }, [
        _vm._v(
          "\n\t\t\tJetzt müsst ihr euch nur noch wegen den Formalitäten kurzschließen!\n\t\t"
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "message-list--employment-info-box" },
        [
          _vm.isInitiatorCustomer && _vm.message.disclosedData
            ? [
                _c("div", [
                  _vm._v(_vm._s(_vm.message.disclosedData.nameWithSalutation))
                ]),
                _vm._v(" "),
                _vm.message.disclosedData.phone
                  ? _c("div", [
                      _vm._v(_vm._s(_vm.message.disclosedData.phone.formatted))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.message.disclosedData.email
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "mailto:" + _vm.message.disclosedData.email
                          }
                        },
                        [_vm._v(_vm._s(_vm.message.disclosedData.email))]
                      )
                    ])
                  : _vm._e()
              ]
            : _vm.message.customer
            ? [
                _c("div", [
                  _vm._v(_vm._s(_vm.message.customer.nameWithSalutation))
                ]),
                _vm._v(" "),
                _vm.message.customer.phone
                  ? _c("div", [
                      _vm._v(_vm._s(_vm.message.customer.phone.formatted))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.message.customer.email
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "mailto:" + _vm.message.customer.email
                          }
                        },
                        [_vm._v(_vm._s(_vm.message.customer.email))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.message.customer.companyName))])
              ]
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }